import { triggerHostMessageOpenThirdPartyWidget } from '../triggerHostMessage/triggerHostMessageOpenThirdPartyWidget';
export default function openThirdPartyWidgetHandler(options) {
  triggerHostMessageOpenThirdPartyWidget(options);
}